import React from 'react';
import {
  Col, Container, Row,
} from 'react-bootstrap';
import Checkbox from 'components/DesignSystem/Checkbox';
import ActionButton from 'components/ActionButton';
import {
  useDeletePastSimulationMutation,
  useListPastSimulationsQuery,
} from 'services/api/products/flux';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useDispatch, useSelector } from 'react-redux';
import {
  togglePastSimulation,
  selectFluxAutomaticControlPanelPastSimulations,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';

export default function New() {
  const dispatch = useDispatch();
  const selectedOptions = useSelector(selectFluxAutomaticControlPanelPastSimulations);
  const { data: pastSimulations } = useListPastSimulationsQuery();
  const isChecked = (simulationId: number) => selectedOptions.includes(simulationId);

  const [
    deletePastSimulation,
    { isLoading: isDeletingPastSimulation, error: deletePastSimulationError },
  ] = useDeletePastSimulationMutation();

  useHandleRequestErrors(deletePastSimulationError as ResponseError);

  return (
    <Container>
      { pastSimulations?.map((pastSimulation) => (
        <Row md={12} key={`past-simulation-${pastSimulation.id}`}>
          <Col className="d-flex">
            <Checkbox
              label={pastSimulation.name}
              onChange={() => dispatch(togglePastSimulation(pastSimulation.id))}
              checked={isChecked(pastSimulation.id)}
              className="flex-grow-1"
            />
            <ActionButton
              loading={isDeletingPastSimulation}
              onClick={() => deletePastSimulation(pastSimulation.id)}
              icon="trash"
              type="tertiary"
              small
            />
          </Col>
        </Row>
      )) }
    </Container>
  );
}
